<template>
  <div>
    <div class="page-body">
      <v-data-table class="app-table" :headers="headers" :items="data" :page.sync="page" :items-per-page="itemsPerPage" hide-default-footer="hide-default-footer" item-key="id" :show-select="true" :value="selected" @input="updateSelected" @page-count="pageCount = $event" :no-data-text="$t('common.nodata')">
        <template v-slot:item.amount="{ item }">
          <number-input v-model="item.amount"></number-input>
        </template>
      </v-data-table>
      <div class="text-center mt-10">
        <v-pagination v-model="page" :length="pageCount"></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import NumberInput from '@/components/Share/NumberInput'

export default {
  components: { NumberInput },
  data () {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      headers: [
        { text: this.$t('tableAccessories.headers.store'), sortable: false, value: 'store' },
        { text: this.$t('tableAccessories.headers.name'), sortable: false, value: 'name' },
        { text: this.$t('tableAccessories.headers.amount'), sortable: false, value: 'amount' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      data: 'accessories/list',
      selected: 'accessories/selected'
    })
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    ...mapActions({
      fetchData: 'accessories/fetch',
      updateSelected: 'accessories/updateSelected'
    })
  }
}
</script>
